import HttpV2 from './HttpV2';

class AudienceServiceV2 {
  static async createAudience(payload) {
    return HttpV2.post(`audience`, payload);
  }

  static async getAudiences() {
    return HttpV2.get(`audience`);
  }

  static async deleteAudience(id) {
    return HttpV2.delete(`audience/${id}`);
  }

  static async updateAudience(id, payload) {
    payload.append('_method', 'PATCH');
    return HttpV2.post(`audience/${id}`, payload);
  }

  static async getScopedAudiences(payload) {
    return HttpV2.get(`audience/scoped`, {
      params: payload,
    });
  }

  static async getAudience(id) {
    return HttpV2.get(`audience/${id}`);
  }

  static async downloadCsvTemplate() {
    return HttpV2.get(`audience/csv-template`);
  }

  static async validateAudienceCsv(payload) {
    return HttpV2.post(`audience/validate-csv`, payload);
  }

  static async getAdminAudiences(payload = {}) {
    return HttpV2.get(`admin/audience`, {
      params: payload,
    });
  }

  static async getAudienceCampaigns(id, payload = {}) {
    return HttpV2.get(`admin/audience/${id}/campaigns`, {
      params: payload,
    });
  }
}

export default AudienceServiceV2;
